import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import './styles/Main.scss';
import Main from './Main';
import MultiLangWrapper from './components/MultiLangWrapper';
import { AppProvider } from './state/app';

const isMetaMaskExtensionNoise = (message = '', stack = '') => {
  const messageText = String(message || '').toLowerCase();
  const stackText = String(stack || '').toLowerCase();
  return messageText.includes('failed to connect to metamask')
    && stackText.includes('chrome-extension://');
};

if (typeof window !== 'undefined') {
  window.addEventListener('error', (event) => {
    const errorMessage = event?.message || event?.error?.message || '';
    const errorStack = event?.error?.stack || '';
    if (isMetaMaskExtensionNoise(errorMessage, errorStack)) {
      event.preventDefault();
    }
  });

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event?.reason;
    const reasonMessage = reason?.message || reason || '';
    const reasonStack = reason?.stack || '';
    if (isMetaMaskExtensionNoise(reasonMessage, reasonStack)) {
      event.preventDefault();
    }
  });
}

ReactDOM.render(
  <AppProvider>
    <BrowserRouter>
      <MultiLangWrapper>
        <Main />
      </MultiLangWrapper>
    </BrowserRouter>
  </AppProvider>,
  document.getElementById('root'),
);
